import mutations from './mutations'
import * as getters from './getters'
import * as actions from './actions'

const initialState = {
    user: {},
    token: '',
    roles: [
        {
            label: 'Super Admin',
            value: 'super_admin'
        },
        {
            label: 'Admin',
            value: 'admin'
        },
        {
            label: 'Member',
            value: 'member'
        },
        {
            label: 'Premium User',
            value: 'premium_user'
        },
        {
            label: 'Creator',
            value: 'creator'
        },
        {
            label: 'Contributor',
            value: 'contributor'
        },
        {
            label: 'Translator',
            value: 'translator'
        },
        {
            label: 'Teacher Basic',
            value: 'teacher'
        },
        {
            label: 'Student Basic',
            value: 'student'
        },
        {
            label: 'Teacher Plus',
            value: 'teacher_plus'
        },
        {
            label: 'Student Plus',
            value: 'student_plus'
        }
        // {
        //     label: 'Partner',
        //     value: 'partner'
        // }
    ],

    registerProviders: [
        {
            label: 'Normal',
            value: 'normal'
        },
        {
            label: 'Facebook',
            value: 'facebook'
        },
        {
            label: 'Gmail',
            value: 'gmail'
        },
        {
            label: 'Vipps',
            value: 'vipps'
        },
        {
            label: 'Feide',
            value: 'feide'
        },
    ]
}

export default {
    namespaced: true,

    state: initialState,

    getters: getters,

    actions: actions,

    mutations: mutations
}
